import {
  ChangeDetectionStrategy,
  Component,
  ComponentFactoryResolver,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TableCellAnchorDirective } from './table-cell-anchor.directive';
import { DataTypeService } from '../data-type/services/data-type.service';
import { DataType, DataTypeComponent } from '../data-type/data-type-component';
import { FieldConfigDTO } from '../../../system/system-dtos';
import { createRefUrl } from '../utils/ref-url-utils';

@Component({
  selector: 'app-table-cell',
  template: ` <span class="ref-container" [ngClass]="{ 'ref-element': isRef() }">
    @if (isRef()) {
      <a class="link" routerLink="{{ toUrl() }}"></a>
    }
    <ng-template appTableCellHost></ng-template>
  </span>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      .ref-element {
        cursor: pointer !important;
        transition: 0.5s;
        color: #4a89dc;
        text-decoration: underline;
        width: 100%;
      }
      .ref-container {
        display: block;
        padding: 4px 0;
        line-height: 20px;
        position: relative;
      }
      .link {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        opacity: 0;
        height: 20px;
      }
    `,
  ],
  standalone: false,
})
export class TableCellComponent implements OnInit, OnDestroy, OnChanges {
  @Input() type: DataType;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  @Input() formGroup: UntypedFormGroup;

  @Input() rowData: any;

  @ViewChild(TableCellAnchorDirective, { static: true })
  tableCellHost: TableCellAnchorDirective;

  private instance: DataTypeComponent;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private dataTypeService: DataTypeService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.loadComponent();
  }

  ngOnDestroy() {}

  loadComponent() {
    const tableCellComponent = this.dataTypeService.getTableCellComponent(this.type);
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(tableCellComponent);
    const { viewContainerRef } = this.tableCellHost;

    const componentRef = viewContainerRef.createComponent(componentFactory);

    this.instance = <DataTypeComponent>componentRef.instance;
    this.instance.data = this.data;
    this.instance.fieldConfig = this.fieldConfig;
    this.instance.editMode = this.editMode;
    this.instance.formGroup = this.formGroup;
    this.instance.setRowData(this.rowData);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.instance) {
      return;
    }

    if (changes.data) {
      this.instance.data = changes.data.currentValue;
    }

    if (changes.editMode) {
      this.instance.editMode = changes.editMode.currentValue;
    }
  }

  isRef() {
    return !this.editMode && this.fieldConfig.ref && this.rowData;
  }

  toUrl(): string {
    return createRefUrl(this.fieldConfig, this.rowData, this.route);
  }
}
